import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { NavLink, Route, Switch } from 'react-router-dom';

import Gravatar from '../../base/Gravatar';
import { selectUser } from '../../redux/auth/selectors';
import CompanySubHeader from '../layouts/partials/CompanySubHeader';
import ProfileDetails from './ProfileDetails';
import ProfileEdit from './ProfileEdit';
import TwoFactor from './TwoFactor';

class _Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    user: PropTypes.object,
  };

  UNSAFE_componentWillMount() {}

  render() {
    const { user } = this.props;

    return [
      <CompanySubHeader title="Profile" key="subheader" />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-lg-4">
            <div className="m-portlet">
              <div className="m-portlet__body">
                <div className="m-card-profile">
                  <div className="m-card-profile__title m--hide">
                    <Trans>Your Profile</Trans>
                  </div>
                  <div className="m-card-profile__pic">
                    <div className="m-card-profile__pic-wrapper">
                      <Gravatar user={user} />
                    </div>
                  </div>
                  <div className="m-card-profile__details">
                    <span className="m-card-profile__name">
                      {user.firstName} {user.lastName}
                    </span>
                    <a href="" className="m-card-profile__email m-link">
                      {user.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="m-portlet m-portlet--tabs  ">
              <div className="m-portlet__head">
                <div className="m-portlet__head-tools">
                  <ul
                    className="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <NavLink exact className="nav-link m-tabs__link" data-toggle="tab" to="/profile" role="tab">
                        <i className="flaticon-share m--hide" />
                        <Trans>My Details</Trans>
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                        to="/profile/edit"
                        className="nav-link m-tabs__link"
                        data-toggle="tab"
                        href="#m_user_profile_tab_2"
                        role="tab"
                      >
                        <Trans>Edit Profile</Trans>
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                        to="/profile/two-factor"
                        className="nav-link m-tabs__link"
                        data-toggle="tab"
                        href="#m_user_profile_tab_3"
                        role="tab"
                      >
                        <Trans>Two Factor Authentication</Trans>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="tab-content">
                <div className="tab-pane active">
                  <Switch>
                    <Route path="/profile/two-factor" component={TwoFactor} />
                    <Route path="/profile/edit" component={ProfileEdit} />
                    <Route path="/profile" component={ProfileDetails} />
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
    ];
  }
}

const mapStateToProps = function (state) {
  return {
    user: selectUser(state),
  };
};

const mapDispatchToProps = (dispatch) => ({});

const Profile = connect(mapStateToProps, mapDispatchToProps)(_Profile);

export default Profile;
